import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "8",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.21 7.411a.78.78 0 0 1-.56-.232L5.937 2.465 1.221 7.148A.791.791 0 0 1 .103 6.093L5.377.819a.79.79 0 0 1 1.118 0l5.274 5.274a.79.79 0 0 1 0 1.118.78.78 0 0 1-.56.2" }, null, -1)
  ])))
}
export default { render: render }